import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropzone from 'react-dropzone';

// Components
import * as icons from '../Icons/Icons';

const FileUpload = observer(class FileUpload extends React.Component {
  constructor() {
    super();
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.removeFile = this.removeFile.bind(this);
  }

  componentWillMount() {
    this.state = {
      attachment: [],
      dropClass: ''
    }
  }

  handleDrop(file, rejected) {
    const { SessionStore } = this.props.store;
    const { onDrop } = this.props;
    let size = 0;
    let maxFileSize = 4194304;

    if(this.props.maxSize) {
      maxFileSize = this.props.maxSize;
    }

    if(file.length === 0) {
      const dialogContent = this.props.translation.invalid;
      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    } else {
      file.forEach(function(file){
        if(file.size) {
          size += file.size
        }
      });
    }

    if(this.state.attachment.length + file.length <= 5 && size <= maxFileSize) {
      let attachment = [...this.state.attachment.concat(file)];

      this.setState({
        attachment,
        dropClass: ''
      });

      if(onDrop) {
        onDrop(attachment);
      }
    } else {
      let dialogContent = this.props.translation.limit;

      if(size > maxFileSize) {
        dialogContent = this.props.translation.too_large;
      }

      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    }
  }

  handleDragEnter() {
    this.setState({
      dropClass: 'file-drop--drag-enter'
    });
  }

  handleDragLeave() {
    this.setState({
      dropClass: ''
    });
  }

  removeFile(i) {
    let attachment = [...this.state.attachment];
    attachment.splice(i, 1);

    this.setState({
      attachment
    });
  }

  deleteFile(file, index) {
    const { ExamStore } = this.props.store;

    if((this.props.exception && this.props.customConfiguration.sid) || !this.props.exception) {
      ExamStore.deleteAttachments.push(file);
    }

    this.removeUploadedFile(index);
  }

  removeUploadedFile(index) {
    if(!this.props.exception) {
      this.props.exam.configuration.attachments.splice(index, 1);
    } else {
      this.props.customConfiguration.attachments.splice(index, 1);
    }
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { files, fileType, maxSize, single } = this.props;

    let maxFileSize = 30000000; // set to 30MB to match the API.

    if(maxSize) {
      maxFileSize = maxSize;
    }

    if(!SessionStore.loading) {
      return(
        <div>
          {
            !this.props.readonly &&
            (
              (
                this.props.single &&
                (this.state.attachment.length === 0 && (!files || files.length === 0))
              ) ||
              !this.props.single
            ) &&

            <Dropzone
              className={`file-drop ${this.state.dropClass}`}
              onDrop={this.handleDrop}
              onDragEnter={this.handleDragEnter}
              onDragLeave={this.handleDragLeave}
              multiple={single ? false : true}
              accept={fileType ? fileType : 'audio/*, image/*, text/*, video/*, application/*, application/octet-stream'}
              maxSize={maxFileSize}
            >
              <label className="file-drop__label">
                {this.props.label ? this.props.label : translation.label}
              </label>

              {this.props.helper &&
                <span className="file-drop__helper">
                  {this.props.helper}
                </span>
              }

              {/* {this.props.onCancel && !files &&
                <button
                  className="btn--link"
                  onClick={this.props.onCancel}
                >
                  {translation.cancel}
                </button>
              } */}
            </Dropzone>
          }

          {(this.state.attachment.length > 0 || (files && files.length > 0)) &&
            <ul className="file-drop__files">
              {/* Existing files */}
              {files && files.length > 0 && files.map(
                (file, i) =>
                <li key={i}>
                  <span>{file.attachmentAwsTitle}</span>

                  <button
                    className="btn--remove"
                    type="button"
                    onClick={() => this.deleteFile(file.attachmentAwsTitle, i)}
                    disabled={this.props.readonly ? true : false}
                  >
                    <icons.iconMinus />
                    <span className="meta">
                      {translation.remove} {file.name}
                    </span>
                  </button>
                </li>
              )}

              {/* Newly added files */}
              {this.state.attachment.map(
                (file, i) =>
                <li key={i}>
                  <span>{file.name}</span>

                  <button
                    className="btn--remove"
                    type="button"
                    onClick={() => this.removeFile(i)}
                    disabled={this.props.readonly ? true : false}
                  >
                    <icons.iconMinus />
                    <span className="meta">
                      {translation.remove} {file.name}
                    </span>
                  </button>
                </li>
              )}
            </ul>
          }
        </div>
      );
    }

    return null;
  }
})

export default translate('FileUpload')(FileUpload);



// WEBPACK FOOTER //
// ./src/app/components/Modules/FileUpload.js